import { Component, OnInit, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDrawer } from '@angular/material/sidenav';
import { DataLakeFileDateListing } from 'src/app/models/data-lake/files/data-lake-file-date-listing';
import { DataLakeFileListing } from 'src/app/models/data-lake/files/data-lake-file-listing';
import { DataLakeService } from 'src/app/services/data-lake.service';
import { DisplayService } from 'src/app/services/display.service';
import { StringLocalizerService } from "src/app/services/string-localizer.service";
import { BusinessLogicService } from 'src/app/services/business-logic.service';


@Component({
    selector: 'app-data-lake',
    templateUrl: './data-lake.component.html',
    styleUrls: ['./data-lake.component.css'],
    standalone: false
})
export class DataLakeComponent implements OnInit {
  integrationName: string = '';
  integrationDisplayName: string = '';
  selectedDataLakeSolution: string = "";
  selectedDataLakeData: any = null;
  selected3 = [];
  show = false;
  isMasterSel: boolean = false;
  categoryList: any;
  checkedCategoryList: any;
  fileDates: DataLakeFileDateListing[] = [];
  files: DataLakeFileListing[] = [];
  selectedDate: string = null;
  noFiles: boolean = false;
  public isDrawerOpen: boolean = false;
  toggleSearchCoontainer: boolean = false;
  searchFileList: string = "";
  filteredFiles: DataLakeFileListing[] = [];
  public strings: {} = {};
  @ViewChild('drawer', { static: false }) public drawer?: MatDrawer;
  
  constructor(
    private dataLakeService: DataLakeService,
    private displayService: DisplayService,
    private stringLocalizerService: StringLocalizerService,
    private businessLogicService: BusinessLogicService) {
      this.stringLocalizerService.strings.subscribe(s => {
        if (s) {
          this.strings = this.stringLocalizerService.getSection("output");
        }
      })
  }

  ngOnInit() {
    this.dataLakeService.$dataLakeFiles.subscribe(dataLakeFiles => {
      if (dataLakeFiles != null) {
        this.selectedDataLakeSolution = this.displayService.$selectedDataLakeSolution.value;
        this.integrationName = this.selectedDataLakeSolution;
        this.integrationDisplayName = this.getIntegrationDisplayName(this.integrationName);
        this.displayService.setSelectedSpanText(this.integrationDisplayName);
        var selectedDataLakeData = dataLakeFiles.solutionListings.find(s => s.name == this.selectedDataLakeSolution);
        if (selectedDataLakeData != null) {
          this.fileDates = selectedDataLakeData.dateListings;
          this.drawer?.open()
        }
      }
      else {
        this.fileDates = [];
        this.drawer?.open();
      }
    });
  }

  async selectDate(date: DataLakeFileDateListing): Promise<void> {
    this.setDataStudioTitle(date.longDate);
    await this.getFileNames(date.utcDate);
    this.drawer?.close();
  }

  private getIntegrationDisplayName(integrationName: string): string {
    const integration = this.businessLogicService.listIntegrations().find(i => i.name === integrationName);
    return integration?.alias ?? integrationName;
  }

  //Get names of all files under a certain integration + date
  async getFileNames(date: string): Promise<void> {
    this.displayService.$selectedGrayOut.next(true);
    this.show = true;
    if (this.selectedDate == null || this.selectedDate != date) {
      this.selectedDate = date;
      await this.dataLakeService.loadDataLakeFiles(this.selectedDataLakeSolution, date);
      const solutionListing = this.dataLakeService.$dataLakeFiles.value?.solutionListings.find(s => s.name == this.selectedDataLakeSolution);
      const dateListing = solutionListing?.dateListings.find(d => d.name == date);

      this.files = [...(dateListing?.filesListing ?? [])];
      this.filteredFiles = [...this.files];
      this.toggleSearchCoontainer = true;
      this.noFiles = this.files.length == 0;
    }
    this.displayService.$selectedGrayOut.next(false);
  }


  //Download selected file to browser
  async downloadFile(file: DataLakeFileListing): Promise<void> {
    await this.dataLakeService
      .getIOFile(this.selectedDataLakeSolution, this.selectedDate, `${file.name}.${file.extension}`).then(blob => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(blob)
        a.href = objectUrl
        a.download = `${file.name}.${file.extension}`;
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  setDataStudioTitle(title: string) {
    this.displayService.setDataStudioTitle(title);
  }

  //Track if mat-drawer is open or close.
  onOpenedChange(event) {
    this.isDrawerOpen = !this.isDrawerOpen;
  }

  toggle(filteredFiles, event: MatCheckboxChange) {
    if (event.checked) {
      this.selected3.push(filteredFiles);
    } else {
      const index = this.selected3.indexOf(filteredFiles);
      if (index >= 0) {
        this.selected3.splice(index, 1);
      }
    }
  }

  exists(item) {
    return this.selected3.indexOf(item) > -1;
  };

  isIndeterminate() {
    return (this.selected3.length > 0 && !this.isChecked());
  };

  isChecked() {
    return this.selected3.length === this.filteredFiles.length;
  };



  toggleAll(event: MatCheckboxChange) {

    if (event.checked) {

      this.filteredFiles.forEach(row => {
        this.selected3.push(row)
      });

    } else {
      this.selected3.length = 0;
    }
  }

  async downloadAllChecked(): Promise<void> {
    for (const file of this.selected3) {
      await this.downloadFile(file);
      await this.delay(100);
    }
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Filter Files
  filterFileList() {
    const searchLower = this.searchFileList.toLocaleLowerCase();
    this.filteredFiles = this.files.filter((file) =>
      file.name.toLowerCase().includes(searchLower)
    );
  }
}
